<template>
  <p :class="isValid ? 'success--text' : ''" class="mb-1">
    <v-icon style="color: inherit;" size="15">
      {{ isValid ? 'mdi-check' : 'mdi-circle-medium' }}
    </v-icon>
    {{ ruleText }}
  </p>
</template>


<script>
export default {
  name: "RuleBulletPoint",
  props: {
    value: [String, Number],
    rule: Function,
  },

  data() {
    return {

    };
  },


  methods: {},

  computed: {
    isValid() {
      return this.rule(this.value) != this.rule(null);
    },

    ruleText() {
      return this.rule(null);
    },
  },

  watch: {},
};
</script>


<style lang="scss"></style>